const initialState = {
    data: [],
    page: 1,
    lastPageNumber: 99999999,

    alreadyMounted: false,
};

function documentsReducer(state = initialState, action) {
    let nextState;
    switch (action.type) {
        case "SET_DOCUMENT_DATA":
            nextState = {
                ...state,
                data: action.value,
            };
            return nextState || state;
        case "SET_DOCUMENT_PAGE":
            nextState = {
                ...state,
                page: action.value,
            };
            return nextState || state;
        case "SET_DOCUMENT_LAST_PAGE":
            nextState = {
                ...state,
                lastPageNumber: action.value,
            };
            return nextState || state;
        case "SET_DOCUMENT_TOTAL":
            nextState = {
                ...state,
                total: action.value,
            };
            return nextState || state;
        case "SET_DOCUMENT_ALREADY_MOUNTED":
            nextState = {
                ...state,
                alreadyMounted: action.value,
            };
            return nextState || state;
        default:
            return state;
    }
}

export default documentsReducer;